import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import {Router} from "@angular/router";
import {MatDrawer} from "@angular/material/sidenav";
import {UiManagerService} from "../../services/ui-manager.service";
import {environment} from "@environments/environment";
import {MaintenanceManagerService} from "../../services/maintenance-manager.service";
import {AccountManagerService} from "../../services/account-manager-service";
import {TranslatePipe} from "@ngx-translate/core";
import { version } from "../../../../package.json";
import {SettingsManagerService} from "../../services/settings-manager.service";

declare const $: any;

@Component({
  selector: 'app-scotty-layout',
  templateUrl: './scotty-layout.component.html',
  styleUrls: ['./scotty-layout.component.scss']
})
export class ScottyLayoutComponent implements OnInit, AfterViewInit {

  collapsedSidebar: boolean;

  showPrivacyPolicy: boolean;

  @ViewChild(MatDrawer)
  sidebar: MatDrawer;

  constructor(
    public settingsManagerService: SettingsManagerService,
    public accountManagerService: AccountManagerService,
    private maintenanceManagerService: MaintenanceManagerService,
    private uiManagerService: UiManagerService,
    private translatePipe: TranslatePipe,
    private router: Router
  ) {
    this.showPrivacyPolicy = environment.showPrivacyPolicy;
  }

  ngOnInit(): void {
    this.accountManagerService.onLoginStatusChanged.subscribe(status => {
      if (status) {
        this.settingsManagerService.getCartographicConsoleConfig();
        this.maintenanceManagerService.init();
      } else {
        this.maintenanceManagerService.dispose();
      }
    });
  }

  ngAfterViewInit(): void {
    this.uiManagerService.setSidebar(this.sidebar);
  }

  async logout() {
    this.uiManagerService.showConfirmDialog(this.translatePipe.transform('Logout'), this.translatePipe.transform('Are you sure do you want to logout?'), async () => {
      await this.accountManagerService.logout();
    });
  }

  goToPage(pageUrl: string) {
    this.router.navigate([pageUrl]);
  }

  isSelected(pageUrl: string) {
    return pageUrl === this.router.url.split('/')[1];
  }

  collapseSidebar() {
    if (this.sidebar.opened) {
      this.collapsedSidebar = !this.collapsedSidebar;
      if (this.collapsedSidebar) {
        $('.bottom-sidebar > .expanded-list').fadeOut(200);
        $('.bottom-sidebar > .collapsed-list').delay(200).fadeIn(200);
      } else {
        $('.bottom-sidebar > .collapsed-list').fadeOut(200);
        $('.bottom-sidebar > .expanded-list').delay(200).fadeIn(200);
      }
    } else {
      this.uiManagerService.notify(this.translatePipe.transform('Cannot open sidebar during current operation'));
    }
  }

  get version() { return version; }

  get environment() { return environment; }

}
